export const QUERY_REQUEST_SEND = 'QUERY REQUEST SEND';
export const QUERY_REQUEST_SUCCESS = 'QUERY REQUEST SUCCESS';
export const QUERY_REQUEST_FAILURE = 'QUERY REQUEST FAILURE';
export const QUERY_REQUEST_PROCESSING = 'QUERY REQUEST PROCESSING';

export const STORED_PROCEDURE_REQUEST_SEND = 'STORED_PROCEDURE_REQUEST_SEND';
export const STORED_PROCEDURE_REQUEST_SUCCESS =
  'STORED_PROCEDURE_REQUEST_SUCCESS';
export const STORED_PROCEDURE_REQUEST_FAILURE =
  'STORED_PROCEDURE_REQUEST_FAILURE';
export const STORED_PROCEDURE_REQUEST_PROCESSING =
  'STORED_PROCEDURE_REQUEST_PROCESSING';

export const ADD_CHART = 'ADD_CHART';

export const STORE_SAMPLE_DATA = 'STORE_SAMPLE_DATA';

export const CLEAR_CHARTS = 'CLEAR_CHARTS';
export const CLEAR_MAPS = 'CLEAR_MAPS';
export const CLOSE_CHART = 'CLOSE_CHART';

export const TABLE_STATS_REQUEST_SEND = 'ABLE_STATS_REQUEST_SEND';
export const TABLE_STATS_REQUEST_PROCESSING = 'TABLE_STATS_REQUEST_PROCESSING';
export const TABLE_STATS_REQUEST_SUCCESS = 'TABLE_STATS_REQUEST_SUCCESS';
export const TABLE_STATS_REQUEST_FAILURE = 'TABLE_STATS_REQUEST_FAILURE';

export const CRUISE_TRAJECTORY_REQUEST_SEND = 'CRUISE_TRAJECTORY_REQUEST_SEND';
export const CRUISE_TRAJECTORY_REQUEST_SUCCESS =
  'CRUISE_TRAJECTORY_REQUEST_SUCCESS';
export const CRUISE_TRAJECTORY_REQUEST_FAILURE =
  'CRUISE_TRAJECTORY_REQUEST_FAILURE';
export const CRUISE_TRAJECTORY_REQUEST_PROCESSING =
  'CRUISE_TRAJECTORY_REQUEST_PROCESSING';
export const CRUISE_TRAJECTORY_CLEAR = 'CRUISE_TRAJECTORY_CLEAR';
export const CRUISE_TRAJECTORY_ZOOM_TO = 'CRUISE_TRAJECTORY_ZOOM_TO';

export const CRUISE_LIST_REQUEST_SEND = 'CRUISE_LIST_REQUEST_SEND';
export const CRUISE_LIST_REQUEST_SUCCESS = 'CRUISE_LIST_REQUEST_SUCCESS';
export const CRUISE_LIST_REQUEST_FAILURE = 'CRUISE_LIST_REQUEST_FAILURE';
export const CRUISE_LIST_REQUEST_PROCESSING = 'CRUISE_LIST_REQUEST_PROCESSING';

export const TRIGGER_SHOW_CHARTS = 'TRIGGER_SHOW_CHARTS';
export const COMPLETED_SHOW_CHARTS = 'COMPLETED_SHOW_CHARTS';

export const CSV_FROM_VIZ_REQUEST_SEND = 'CSV_FROM_VIZ_REQUEST_SEND';

export const DOWNLOAD_TEXT_AS_CSV = 'DOWNLOAD_TEXT_AS_CSV';

export const VIZ_PAGE_DATA_TARGET_SET = 'VIZ_PAGE_DATA_TARGET_SET';
export const VIZ_PAGE_DATA_TARGET_DETAILS_STORE =
  'VIZ_PAGE_DATA_TARGET_DETAILS_STORE';
export const VIZ_PAGE_DATA_TARGET_SET_AND_FETCH_DETAILS =
  'VIZ_PAGE_DATA_TARGET_SET_AND_FETCH_DETAILS';

export const VIZ_SEARCH_RESULTS_FETCH = 'VIZ_SEARCH_RESULTS_FETCH';
export const VIZ_SEARCH_RESULTS_STORE = 'VIZ_SEARCH_RESULTS_STORE';
export const VIZ_SEARCH_RESULTS_STORE_AND_UPDATE_OPTIONS =
  'VIZ_SEARCH_RESULTS_STORE_AND_UPDATE_OPTIONS';
export const VIZ_SEARCH_RESULTS_SET_LOADING_STATE =
  'VIZ_SEARCH_RESULTS_SET_LOADING_STATE';

export const MEMBER_VARIABLES_FETCH = 'MEMBER_VARIABLES_FETCH';
export const MEMBER_VARIABLES_STORE = 'MEMBER_VARIABLES_STORE';
export const MEMBER_VARIABLES_SET_LOADING_STATE =
  'MEMBER_VARIABLES_SET_LOADING_STATE';

export const RELATED_DATA_FETCH = 'RELATED_DATA_FETCH';
export const RELATED_DATA_STORE = 'RELATED_DATA_STORE';
export const RELATED_DATA_SET_LOADING_STATE = 'RELATED_DATA_SET_LOADING_STATE';

export const VARIABLE_NAME_AUTOCOMPLETE_FETCH =
  'VARIABLE_NAME_AUTOCOMPLETE_FETCH';
export const VARIABLE_NAME_AUTOCOMPLETE_STORE =
  'VARIABLE_NAME_AUTOCOMPLETE_STORE';

export const VARIABLE_FETCH = 'VARIABLE_FETCH';
export const VARIABLE_STORE = 'VARIABLE_STORE';
export const VARIABLE_FETCH_SET_LOADING_STATE =
  'VARIABLE_FETCH_SET_LOADING_STATE';

export const DATASET_SUMMARY_FETCH = 'DATASET_SUMMARY_FETCH';
export const DATASET_SUMMARY_STORE = 'DATASET_SUMMARY_STORE';

export const PLOTS_ACTIVE_TAB_SET = 'PLOTS_ACTIVE_TAB_SET';

export const SPARSE_DATA_QUERY_SEND = 'SPARSE_DATA_QUERY_SEND';

export const SPARSE_DATA_MAX_SIZE_NOTIFICATION_UPDATE =
  'SPARSE_DATA_MAX_SIZE_NOTIFICATION_UPDATE';

export const HANDLE_GUEST_VISUALIZATION = 'HANDLE_GUEST_VISUALIZATION';

export const GUEST_PLOT_LIMIT_NOTIFICATION_SET_IS_VISIBLE =
  'GUEST_PLOT_LIMIT_NOTIFICATION_SET_IS_VISIBLE';

export const DATA_SEARCH_VISIBILITY = 'DATA_SEARCH_VISIBILITY';

export const VIZ_CONTROL_PANEL_VISIBILITY = 'VIZ_CONTROL_PANEL_VISIBILITY';

export const TRAJECTORY_POINT_COUNT_FETCH = 'TRAJECTORY_POINT_COUNT_FETCH';
export const TRAJECTORY_POINT_COUNT_SUCCESS = 'TRAJECTORY_POINT_COUNT_SUCCESS';
export const TRAJECTORY_POINT_COUNT_FAILURE = 'TRAJECTORY_POINT_COUNT_FAILURE';

export const SET_PARAM_LOCK = 'SET_PARAM_LOCK';
export const SET_LOCK_ALERTS_OPEN = 'SET_LOCK_ALERTS_OPEN';

export const CHECK_VIZ_QUERY_SIZE = 'CHECK_VIZ_QUERY_SIZE';
export const SET_CHECK_VIZ_QUERY_SIZE_STATUS =
  'SET_CHECK_VIZ_QUERY_SIZE_STATUS';
export const CHECK_VIZ_QUERY_SIZE_STORE = 'CHECK_VIZ_QUERY_SIZE_STORE';
